import { Controller, ControllerProps, FieldError, FieldValues, Path } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { FormErrorHelperText } from '../FormErrorHelperText';
import { DateNumberFormat, DateNumberFormatProps } from './DateNumberFormat';

export const YearInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>
>({
  controllerProps,
  error,
  ...dateNumberFormatProps
}: {
  controllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
  error?: FieldError;
} & DateNumberFormatProps) => {
  return (
    <Controller
      {...controllerProps}
      render={({ field: { ref, ...rest } }) => (
        <DateNumberFormat
          error={Boolean(error)}
          helperText={<FormErrorHelperText error={error} fieldName="Year" />}
          format="####"
          inputRef={ref}
          label={<FormattedMessage id="year" defaultMessage="Year" />}
          mask="Y"
          {...dateNumberFormatProps}
          {...rest}
        />
      )}
    />
  );
};
